export enum NotificationMode {
    NONE = 'None',
    WHATSAPP = 'Whatsapp',
    EMAIL = 'Email',
    SMS = 'Sms',
}

export enum NotificationTemplateStatus {
    UNDER_REVIEW = 'UNDER_REVIEW',
    APPROVED = 'APPROVED',
}